<template>
  <div>
    <div class="main-container d-flex flex-md-row flex-column">
      <div>
        <h2 class="page-caption">{{ $t('labels.acc.side.userCenter') }}</h2>
        <div>
          <CollapseMenu :menu-data="menuData"></CollapseMenu>
        </div>
      </div>

      <div class="right-content flex-fill ml-md-3 mt-md-0 mt-3">
        <router-view/>
      </div>
    </div>

    <!--侧滑菜单 start-->
    <!--<q-layout-drawer
      v-if="showLeftDrawer"
      v-model="leftDrawerShow"
      :width="280"
      side="left"
      class="left-drawer-menu">
      <h2 class="page-caption">{{ $t('labels.acc.side.userCenter') }}</h2>
      <CollapseMenu :menu-data="menuData"></CollapseMenu>
    </q-layout-drawer>-->
    <!--侧滑菜单 end-->
  </div>
</template>

<script>
  import CollapseMenu from '@/components/Menu/CollapseMenu/CollapseMenu.vue';

  import sliderMenuControl from '@/common/mixin/sliderMenuControl';

  // import { openURL } from 'quasar';
  export default {
    name: 'usercenter',
    mixins: [sliderMenuControl],
    data() {
      return {
        // 侧滑菜单是否显示
        sliderMenuId: 'usercenter',
        menuData: [
          {
            text: this.$t('labels.acc.side.accMsgs'), // 菜单名字
            isRoute: true, // 是否是路由，默认为true。如果值为false，则此菜单不会使用<router-link>，而是使用普通的a标签
            url: '/safd', // 路由跳转路径，如果值为空，则会使用普通a标签代替，并且href为"javascript: void(0);"
            hasIcon: true, // 是否有图标
            iconName: '#icon-icon-test1', // 图标名称，这里的图标使用的iconfont.cn中的icon，并且使用的是symbol模式
            // 子菜单
            children: [
              { text: this.$t('labels.acc.side.accMgmt'), url: '/usercenter/account-management' },
              // { text: '邮箱验证', url: '/usercenter/email-bind', baseUrl: '/usercenter/email-bind' },
              {
                text: this.$t('labels.ga'),
                url: '/usercenter/google-verification-bind',
                baseUrl: '/usercenter/google-verification-bind'
              },
              {
                text: this.$t('labels.acc.side.maxRegister'),
                url: '/usercenter/max-register-bind',
                baseUrl: '/usercenter/max-register-bind'
              },
              { text: this.$t('labels.acc.loginPwd'), url: '/usercenter/login-pwd-bind' },
              {
                text: this.$t('labels.acc.side.mobileVerf'),
                url: '/usercenter/phone-bind',
                baseUrl: '/usercenter/phone-bind'
              },
              {
                text: this.$t('labels.acc.txnPwd'),
                url: '/usercenter/traders-pwd-bind',
                baseUrl: '/usercenter/traders-pwd-bind'
              }
              // { text: '防钓鱼码', url: '/usercenter/prevent-deceive-code' },
            ]
          },
          {
            text: this.$t('labels.acc.side.idVerf'),
            url: '/usercenter/authentication',
            hasIcon: true,
            iconName: '#icon-icon-test4'
          },
          // { text: '高级认证', url: '/usercenter/senior-certification', hasIcon: true, iconName: '#icon-icon-test5' },
          // { text: '费率设置', url: '/usercenter/fee-rate', hasIcon: true, iconName: '#icon-icon-test5' },
          // { text: '会员等级', url: '/usercenter/member-discount', hasIcon: true, iconName: '#icon-icon-test2' },
          // { text: '合伙人', url: '/usercenter/partner', hasIcon: true, iconName: '#icon-icon-test2' },
          // { text: '地址本', url: '/usercenter/address-book', hasIcon: true, iconName: '#icon-icon-test2' },
          /*{
            text: this.$t('labels.acc.side.myReward'),
            url: '/usercenter/my-reward',
            hasIcon: true,
            iconName: '#icon-icon-test6'
          },
          {
            text: this.$t('labels.acc.side.affiliate'),
            url: '/affiliate-invite',
            hasIcon: true,
            iconName: '#icon-icon-test6'
          },

          {
            text: this.$t('labels.acc.side.relationTree'),
            url: '/usercenter/relation-team',
            hasIcon: true,
            iconName: '#icon-icon-test2'
          },*/
          {
            text: this.$t('labels.acc.inboxMsg.notification'),
            url: '/usercenter/messages',
            hasIcon: true,
            iconName: '#icon-icon-test6'
          },
          {
            text: this.$t('labels.acc.side.loginRecord'),
            url: '/usercenter/login-record',
            hasIcon: true,
            iconName: '#icon-icon-test'
          }
        ]
      };
    },
    methods: {
      // openURL,
    },
    components: {
      CollapseMenu
    }
  };
</script>

<style lang="stylus" scoped>
  @import 'usercenter.scoped.styl';
</style>
